/**
 * Get an object value from a specific path
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object}       obj  The object
 * @param  {String|Array} path The path
 * @param  {*}            def  A default value to return [optional]
 * @return {*}                 The value
 */
export var get = function (obj, path, def) {
    /**
     * If the path is a string, convert it to an array
     * @param  {String|Array} path The path
     * @return {Array}             The path array
     */
    var stringToPath = function (localPath) {
        // If the path isn't a string, return it
        if (typeof localPath !== 'string') {
            return localPath;
        }
        // Create new array
        var output = [];
        // Split to an array with dot notation
        localPath.split('.').forEach(function (item) {
            // Split to an array with bracket notation
            item.split(/\[([^}]+)\]/g).forEach(function (key) {
                // Push to the new array
                if (key.length > 0) {
                    output.push(key);
                }
            });
        });
        return output;
    };
    // Get the path as an array
    var paths = stringToPath(path);
    // Cache the current object
    var current = obj;
    // For each item in the path, dig into the object
    for (var _i = 0, paths_1 = paths; _i < paths_1.length; _i++) {
        var loopPath = paths_1[_i];
        // If the item isn't found, return the default (or null)
        if (current[loopPath] === undefined)
            return def;
        // Otherwise, update the current  value
        current = current[loopPath];
    }
    return current;
};
